import React from "react";
import CsplLabel from "../../../CsplControls/CsplLabel/CsplLabel";
import styles from "../Preview.module.css";
import { OptionsEnum } from "../../../../Enumeration/OptionsEnum";
import { convertDateToString } from "../../../../Utils/DateUtils";
import { Accordion } from 'react-bootstrap';
 import "../../../CsplControls/CsplAccordion/CsplAccordion.css";
function NomineeView(props) {
  return (
    <>
      <Accordion className='parentaccordion_style' >
      {/* Nominee Info */}
      <div>
      <Accordion.Item eventKey="0" className='mb-3'>
        <Accordion.Header> 
        <span className="w-100"><CsplLabel label={"title.NomineeDetail"}></CsplLabel></span>
        </Accordion.Header>

        <Accordion.Body>
        <div className='dotted_line'>

      {/* Nominee 1*/}
     {/*  <Accordion.Item ></Accordion.Item> */}
     <Accordion  className="childaccordion_style"  >
       <Accordion.Item eventKey="1" className="m-0 p-0">
      {props && props.data && props.data.nomineeWidgetDTO && 
      <div className={styles.table_content}>

       <Accordion.Header className="mb-0">
          <span className={styles.header}>
            <CsplLabel label={"title.Nominee1"}></CsplLabel>
          </span>
       
        </Accordion.Header>

        <Accordion.Body className={styles.accordion_table}>
        <table className="table table-striped table-bordered border-white table-responsive">
          <tbody className={styles.table_alternate_color}>

             <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.nomineeMinor"}></CsplLabel>
                  </th>
                  <td>{props.data.nomineeWidgetDTO.nominee1.isMinor}</td>
              </tr>
            
              <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.dob"}></CsplLabel>
                  </th>
                  {props.data.nomineeWidgetDTO.nominee1.minorDOB ? <td>{convertDateToString(props.data.nomineeWidgetDTO.nominee1.minorDOB, 'DD-MM-YYYY')}</td>:<td></td>}
                </tr>      
            
            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.prefix"}></CsplLabel>
              </th>
              <td>
                {props.data.nomineeWidgetDTO.nominee1.salutation.shortName}
              </td>
            </tr>

            <tr>
              {" "}
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.name"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.name}</td>
            </tr>

            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.relationshipWithAccountHolder"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.relationship.name}</td>
            </tr>
            {props.data.nomineeWidgetDTO.nominee1 && props.data.nomineeWidgetDTO.nominee1.otherRelationship &&
              <tr>
                <th className={styles.table_header}>
                  <CsplLabel label={"nominee.otherRelationship"}></CsplLabel>
                </th>
                <td>{props.data.nomineeWidgetDTO.nominee1.otherRelationship}</td>
              </tr>
            }

             <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.residentialStatus"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.residentialStatus}</td>
            </tr>

            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.addressLine1"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.addressLine1}</td>
            </tr>

            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.addressLine2"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.addressLine2}</td>
            </tr>

            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.addressLine3"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.addressLine3}</td>
            </tr>

            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.city"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.city}</td>
            </tr>

            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.country"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.country.name}</td>
            </tr>

            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.state"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.state.name}</td>
            </tr>

            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.pincode"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.pincode}</td>
            </tr>

            {props.data.nomineeWidgetDTO.nominee1 && props.data.nomineeWidgetDTO.nominee1.mobileCountry &&
            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.mobileCountryCode"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.mobileCountry.mobileCountryCode}</td>
            </tr>
            }

            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.mobileno"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.mobileNo}</td>
            </tr>

            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.email"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.emailId}</td>
            </tr>

            <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.bankName"}></CsplLabel>
                    </th>
                    <td>
                      {props.data.nomineeWidgetDTO.nominee1.bankName}
                    </td>
                  </tr>
                

                <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.ifscCode"}></CsplLabel>
                    </th>
                    <td>
                      {props.data.nomineeWidgetDTO.nominee1.ifscCode}
                    </td>
                  </tr>
                <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.branchName"}></CsplLabel>
                    </th>
                    <td>
                      {
                        props.data.nomineeWidgetDTO.nominee1
                          .branchName
                      }
                    </td>
                  </tr>
                <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.bankAccNo"}></CsplLabel>
                    </th>
                    <td>
                      {
                        props.data.nomineeWidgetDTO.nominee1
                          .bankAccountNumber
                      }
                    </td>
                  </tr>
                
              
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.bankAccType"}></CsplLabel>
                    </th>
                    <td>
                      { props.data.nomineeWidgetDTO.nominee1.bankAccountType  &&
                        props.data.nomineeWidgetDTO.nominee1.bankAccountType.name
                      }
                    </td>
                  </tr>

            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.sharePercentage1"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee1.sharePercentage}</td>
            </tr>

              


            {props.data.nomineeWidgetDTO.nominee1.isMinor === OptionsEnum.Yes && (
              <>  
                

                <tr>
                  <th className={styles.table_sub_header} colSpan="2">
                    <CsplLabel label={"nominee.guardianDetail"}></CsplLabel>
                  </th>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.name"}></CsplLabel>
                  </th>
                  <td>
                    {props.data.nomineeWidgetDTO.nominee1.guardianDTO.name}
                  </td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.addressLine1"}></CsplLabel>
                  </th>
                  <td>
                    {
                      props.data.nomineeWidgetDTO.nominee1.guardianDTO
                        .addressLine1
                    }
                  </td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.addressLine2"}></CsplLabel>
                  </th>
                  <td>
                    {
                      props.data.nomineeWidgetDTO.nominee1.guardianDTO
                        .addressLine2
                    }
                  </td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.addressLine3"}></CsplLabel>
                  </th>
                  <td>
                    {
                      props.data.nomineeWidgetDTO.nominee1.guardianDTO
                        .addressLine3
                    }
                  </td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.city"}></CsplLabel>
                  </th>
                  <td>
                    {props.data.nomineeWidgetDTO.nominee1.guardianDTO.city}
                  </td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.country"}></CsplLabel>
                  </th>
                  <td>
                    {
                      props.data.nomineeWidgetDTO.nominee1.guardianDTO.country
                        .name
                    }
                  </td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.state"}></CsplLabel>
                  </th>
                  <td>
                    {
                      props.data.nomineeWidgetDTO.nominee1.guardianDTO.state
                        .name
                    }
                  </td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.pincode"}></CsplLabel>
                  </th>
                  <td>
                    {props.data.nomineeWidgetDTO.nominee1.guardianDTO.pincode}
                  </td>
                </tr>

                {props.data.nomineeWidgetDTO.nominee1 && props.data.nomineeWidgetDTO.nominee1.guardianDTO && props.data.nomineeWidgetDTO.nominee1.mobileCountry &&
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.mobileCountryCode"}></CsplLabel>
                     </th>
                    <td>{props.data.nomineeWidgetDTO.nominee1.guardianDTO.mobileCountry.mobileCountryCode}</td>
                  </tr>
                   }

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.mobileno"}></CsplLabel>
                  </th>
                  <td>
                    {props.data.nomineeWidgetDTO.nominee1.guardianDTO.mobileNo}
                  </td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.email"}></CsplLabel>
                  </th>
                  <td>
                    {props.data.nomineeWidgetDTO.nominee1.guardianDTO.emailId}
                  </td>
                </tr>

                {/* <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.relationship"}></CsplLabel>
                  </th>
                  <td>
                    {
                      props.data.nomineeWidgetDTO.nominee1.guardianDTO
                        .relationship
                    }
                  </td>
                </tr> */}

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.relationshipWithNominee"}></CsplLabel>
                  </th>
                  <td>{props.data.nomineeWidgetDTO.nominee1.guardianDTO.relationship.name}</td>
                </tr>
                
                {props.data.nomineeWidgetDTO.nominee1 && props.data.nomineeWidgetDTO.nominee1.guardianDTO
                && props.data.nomineeWidgetDTO.nominee1.guardianDTO.otherRelationship &&
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.otherRelationship"}></CsplLabel>
                    </th>
                    <td>{props.data.nomineeWidgetDTO.nominee1.guardianDTO.otherRelationship}</td>
                  </tr>
                }
                
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.bankName"}></CsplLabel>
                    </th>
                    <td>
                      {props.data.nomineeWidgetDTO.nominee1.guardianDTO.bankName}
                    </td>
                  </tr>
                

                
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.ifscCode"}></CsplLabel>
                    </th>
                    <td>
                      {props.data.nomineeWidgetDTO.nominee1.guardianDTO.ifscCode}
                    </td>
                  </tr>
                
                
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.branchName"}></CsplLabel>
                    </th>
                    <td>
                      {
                        props.data.nomineeWidgetDTO.nominee1.guardianDTO
                          .branchName
                      }
                    </td>
                  </tr>
                
                
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.bankAccNo"}></CsplLabel>
                    </th>
                    <td>
                      {
                        props.data.nomineeWidgetDTO.nominee1.guardianDTO
                          .bankAccountNumber
                      }
                    </td>
                  </tr>
                
              
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.bankAccType"}></CsplLabel>
                    </th>
                    <td>
                      { props.data.nomineeWidgetDTO.nominee1.guardianDTO.bankAccountType && 
                        props.data.nomineeWidgetDTO.nominee1.guardianDTO
                          .bankAccountType.name
                      }
                    </td>
                  </tr>
                
              </>
            ) }
          </tbody>
        </table>
        </Accordion.Body>
      </div>
      }
       </Accordion.Item>

      {/* Nominee 2 */}
      <Accordion.Item eventKey="2" className="m-0 p-0">
      {props && props.data && props.data.nomineeWidgetDTO &&
        props.data.nomineeWidgetDTO.nomineeCount == 2 && (
          <div className={styles.table_content}>
            <Accordion.Header className="mb-0">
              <span className={styles.header}>
                <CsplLabel label={"title.Nominee2"}></CsplLabel>
              </span>
              </Accordion.Header>
              <Accordion.Body className={styles.accordion_table}> 
            <table className="table table-striped table-bordered border-white table-responsive">
              <tbody className={styles.table_alternate_color}>

              <tr>
                      <th className={styles.table_header}>
                        <CsplLabel label={"nominee.nomineeMinor"}></CsplLabel>
                      </th>
                      <td>{props.data.nomineeWidgetDTO.nominee2.isMinor}</td>
                </tr>

                <tr>
                      <th className={styles.table_header}>
                        <CsplLabel label={"nominee.dob"}></CsplLabel>
                      </th>
                      {props.data.nomineeWidgetDTO.nominee2.minorDOB ? <td>{convertDateToString(props.data.nomineeWidgetDTO.nominee2.minorDOB, 'DD-MM-YYYY')}</td>:<td></td>}
                    </tr>


                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.prefix"}></CsplLabel>
                  </th>
                  <td>
                    {props.data.nomineeWidgetDTO.nominee2.salutation.shortName}
                  </td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.name"}></CsplLabel>
                  </th>
                  <td>{props.data.nomineeWidgetDTO.nominee2.name}</td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.relationshipWithAccountHolder"}></CsplLabel>
                  </th>
                  <td>
                    {props.data.nomineeWidgetDTO.nominee2.relationship.name}
                  </td>
                </tr>
                {
                  props.data.nomineeWidgetDTO.nominee2 && props.data.nomineeWidgetDTO.nominee2.otherRelationship &&
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.otherRelationship"}></CsplLabel>
                    </th>
                    <td>
                      {props.data.nomineeWidgetDTO.nominee2.otherRelationship}
                    </td>
                  </tr>
                }

             <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.residentialStatus"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee2.residentialStatus}</td>
            </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.addressLine1"}></CsplLabel>
                  </th>
                  <td>{props.data.nomineeWidgetDTO.nominee2.addressLine1}</td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.addressLine2"}></CsplLabel>
                  </th>
                  <td>{props.data.nomineeWidgetDTO.nominee2.addressLine2}</td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.addressLine3"}></CsplLabel>
                  </th>
                  <td>{props.data.nomineeWidgetDTO.nominee2.addressLine3}</td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.city"}></CsplLabel>
                  </th>
                  <td>{props.data.nomineeWidgetDTO.nominee2.city}</td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.country"}></CsplLabel>
                  </th>
                  <td>{props.data.nomineeWidgetDTO.nominee2.country.name}</td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.state"}></CsplLabel>
                  </th>
                  <td>{props.data.nomineeWidgetDTO.nominee2.state.name}</td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.pincode"}></CsplLabel>
                  </th>
                  <td>{props.data.nomineeWidgetDTO.nominee2.pincode}</td>
                </tr>

            {props.data.nomineeWidgetDTO.nominee2 && props.data.nomineeWidgetDTO.nominee2.mobileCountry &&
            <tr>
              <th className={styles.table_header}>
                <CsplLabel label={"nominee.mobileCountryCode"}></CsplLabel>
              </th>
              <td>{props.data.nomineeWidgetDTO.nominee2.mobileCountry.mobileCountryCode}</td>
            </tr>
            }

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.mobileno"}></CsplLabel>
                  </th>
                  <td>{props.data.nomineeWidgetDTO.nominee2.mobileNo}</td>
                </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.email"}></CsplLabel>
                  </th>
                  <td>{props.data.nomineeWidgetDTO.nominee2.emailId}</td>
                </tr>

                
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.bankName"}></CsplLabel>
                    </th>
                    <td>
                      {props.data.nomineeWidgetDTO.nominee2.bankName}
                    </td>
                  </tr>
                

                
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.ifscCode"}></CsplLabel>
                    </th>
                    <td>
                      {props.data.nomineeWidgetDTO.nominee2.ifscCode}
                    </td>
                  </tr>
                
                
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.branchName"}></CsplLabel>
                    </th>
                    <td>
                      {
                        props.data.nomineeWidgetDTO.nominee2
                          .branchName
                      }
                    </td>
                  </tr>
                
                
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.bankAccNo"}></CsplLabel>
                    </th>
                    <td>
                      {
                        props.data.nomineeWidgetDTO.nominee2
                          .bankAccountNumber
                      }
                    </td>
                  </tr>
                
                
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.bankAccType"}></CsplLabel>
                    </th>
                    <td>
                      { props.data.nomineeWidgetDTO.nominee2.bankAccountType && 
                        props.data.nomineeWidgetDTO.nominee2.bankAccountType.name
                      }
                    </td>
                  </tr>

                <tr>
                  <th className={styles.table_header}>
                    <CsplLabel label={"nominee.sharePercentage2"}></CsplLabel>
                  </th>
                  <td>{props.data.nomineeWidgetDTO.nominee2.sharePercentage}</td>
                </tr>
                

                {props.data.nomineeWidgetDTO.nominee2.isMinor ===
                  OptionsEnum.Yes && (
                  <>
                    

                    <tr>
                      <th className={styles.table_sub_header} colSpan="2">
                        <CsplLabel label={"nominee.guardianDetail"}></CsplLabel>
                      </th>
                    </tr>

                    <tr>
                      <th className={styles.table_header}>
                        <CsplLabel label={"nominee.name"}></CsplLabel>
                      </th>
                      <td>
                        {props.data.nomineeWidgetDTO.nominee2.guardianDTO.name}
                      </td>
                    </tr>

                    <tr>
                      <th className={styles.table_header}>
                        <CsplLabel label={"nominee.addressLine1"}></CsplLabel>
                      </th>
                      <td>
                        {
                          props.data.nomineeWidgetDTO.nominee2.guardianDTO
                            .addressLine1
                        }
                      </td>
                    </tr>

                    <tr>
                      <th className={styles.table_header}>
                        <CsplLabel label={"nominee.addressLine2"}></CsplLabel>
                      </th>
                      <td>
                        {
                          props.data.nomineeWidgetDTO.nominee2.guardianDTO
                            .addressLine2
                        }
                      </td>
                    </tr>

                    <tr>
                      <th className={styles.table_header}>
                        <CsplLabel label={"nominee.addressLine3"}></CsplLabel>
                      </th>
                      <td>
                        {
                          props.data.nomineeWidgetDTO.nominee2.guardianDTO
                            .addressLine3
                        }
                      </td>
                    </tr>

                    <tr>
                      <th className={styles.table_header}>
                        <CsplLabel label={"nominee.city"}></CsplLabel>
                      </th>
                      <td>
                        {props.data.nomineeWidgetDTO.nominee2.guardianDTO.city}
                      </td>
                    </tr>

                    <tr>
                      <th className={styles.table_header}>
                        <CsplLabel label={"nominee.country"}></CsplLabel>
                      </th>
                      <td>
                        {
                          props.data.nomineeWidgetDTO.nominee2.guardianDTO.country
                            .name
                        }
                      </td>
                    </tr>

                    <tr>
                      <th className={styles.table_header}>
                        <CsplLabel label={"nominee.state"}></CsplLabel>
                      </th>
                      <td>
                        {
                          props.data.nomineeWidgetDTO.nominee2.guardianDTO.state
                            .name
                        }
                      </td>
                    </tr>

                    <tr>
                      <th className={styles.table_header}>
                        <CsplLabel label={"nominee.pincode"}></CsplLabel>
                      </th>
                      <td>
                        {props.data.nomineeWidgetDTO.nominee2.guardianDTO.pincode}
                      </td>
                    </tr>

                    {props.data.nomineeWidgetDTO.nominee2 && props.data.nomineeWidgetDTO.nominee2.guardianDTO && props.data.nomineeWidgetDTO.nominee2.mobileCountry &&
                  <tr>
                    <th className={styles.table_header}>
                      <CsplLabel label={"nominee.mobileCountryCode"}></CsplLabel>
                     </th>
                    <td>{props.data.nomineeWidgetDTO.nominee2.guardianDTO.mobileCountry.mobileCountryCode}</td>
                  </tr>
                   }

                    <tr>
                      <th className={styles.table_header}>
                        <CsplLabel label={"nominee.mobileno"}></CsplLabel>
                      </th>
                      <td>
                        {
                          props.data.nomineeWidgetDTO.nominee2.guardianDTO
                            .mobileNo
                        }
                      </td>
                    </tr>

                    <tr>
                      <th className={styles.table_header}>
                        <CsplLabel label={"nominee.email"}></CsplLabel>
                      </th>
                      <td>
                        {props.data.nomineeWidgetDTO.nominee2.guardianDTO.emailId}
                      </td>
                    </tr>
                    
                    <tr>
                      <th className={styles.table_header}>
                        <CsplLabel label={"nominee.relationshipWithNominee"}></CsplLabel>
                      </th>
                      <td>{props.data.nomineeWidgetDTO.nominee2.guardianDTO.relationship.name}</td>
                    </tr>
                
                    {props.data.nomineeWidgetDTO.nominee2 && props.data.nomineeWidgetDTO.nominee2.guardianDTO
                    && props.data.nomineeWidgetDTO.nominee2.guardianDTO.otherRelationship &&
                      <tr>
                        <th className={styles.table_header}>
                          <CsplLabel label={"nominee.otherRelationship"}></CsplLabel>
                        </th>
                        <td>{props.data.nomineeWidgetDTO.nominee2.guardianDTO.otherRelationship}</td>
                      </tr>
                    }

                      <tr>
                        <th className={styles.table_header}>
                          <CsplLabel label={"nominee.bankName"}></CsplLabel>
                        </th>
                        <td>
                          {
                            props.data.nomineeWidgetDTO.nominee2.guardianDTO
                              .bankName
                          }
                        </td>
                      </tr>
                    

                    
                      <tr>
                        <th className={styles.table_header}>
                          <CsplLabel label={"nominee.ifscCode"}></CsplLabel>
                        </th>
                        <td>
                          {
                            props.data.nomineeWidgetDTO.nominee2.guardianDTO
                              .ifscCode
                          }
                        </td>
                      </tr>
                    

                   
                      <tr>
                        <th className={styles.table_header}>
                          <CsplLabel label={"nominee.branchName"}></CsplLabel>
                        </th>
                        <td>
                          {
                            props.data.nomineeWidgetDTO.nominee2.guardianDTO
                              .branchName
                          }
                        </td>
                      </tr>
                    
                    
                      <tr>
                        <th className={styles.table_header}>
                          <CsplLabel label={"nominee.bankAccNo"}></CsplLabel>
                        </th>
                        <td>
                          {
                            props.data.nomineeWidgetDTO.nominee2.guardianDTO
                              .bankAccountNumber
                          }
                        </td>
                      </tr>
                    
                   
                      <tr>
                        <th className={styles.table_header}>
                          <CsplLabel label={"nominee.bankAccType"}></CsplLabel>
                        </th>
                        <td>
                          { props.data.nomineeWidgetDTO.nominee2.guardianDTO
                            .bankAccountType &&
                            props.data.nomineeWidgetDTO.nominee2.guardianDTO
                              .bankAccountType.name
                          }
                        </td>
                      </tr>
                    
                  </>
                ) }
              </tbody>
            </table>
            </Accordion.Body>
          </div>
        )}    
       </Accordion.Item>
</Accordion>
         </div>  
        </Accordion.Body>
     </Accordion.Item>
     </div>
    </Accordion>
    </>
  );
}

export default NomineeView;
